<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />
    <b-row>
      <b-col md="12">
        <h4 style="text-align: center">4. DATOS DEL EMPLEO, CARGO O COMISIÓN QUE INICIA</h4>
      </b-col>
    </b-row>
      <b-row style="text-align: center">
       <b-col  sm="12" >
        <h5 style="text-align: center" :class="{invalid_input: $v.cargo.tipoOperacion.$error}">Elegir un tipo de operación </h5>
      </b-col> 
         <b-col >
          <b-button
            v-if="status !== 'Concluida'"              
            size="sm"
            :variant="cargo.tipoOperacion == 'AGREGAR'? 'primary' : 'outline-primary'"
            @click="cargo.tipoOperacion = 'AGREGAR'"
            >AGREGAR</b-button>
        </b-col>     
        <b-col >
          <b-button
            v-if="status !== 'Concluida'"              
            size="sm"
            :disabled="!cargo.tipoOperacion"
            :variant="cargo.tipoOperacion == 'SIN CAMBIOS'? 'info' : 'outline-info'"
            @click="cargo.tipoOperacion = 'SIN CAMBIOS'"
            >SIN CAMBIOS</b-button>
        </b-col>
        <b-col >
          <b-button
            v-if="status !== 'Concluida'"
            :variant="cargo.tipoOperacion == 'MODIFICAR'? 'success' : 'outline-success'"
            size="sm"
            :disabled="!cargo.tipoOperacion"
            @click="cargo.tipoOperacion = 'MODIFICAR'"
            >MODIFICAR</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3">
        <b-form-group label="ORDEN DE GOBIERNO ">
          <b-form-select
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            :options="nivelOrdenGobierno"
            v-model="cargo.nivelOrdenGobierno"
            
          ></b-form-select>
        </b-form-group>
        </b-col>
        <b-col md="3">
        <b-form-group label="ÁMBITO PÚBLICO">
          <b-form-select
            :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            :options="ambitoPublico"
            v-model="cargo.ambitoPublico"
            class="mb-3"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group  label="NOMBRE DEL ENTE PÚBLICO">
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.nombreEntePublico"
            placeholder="NOMBRE DEL ENTE PÚBLICO"
            :class="{invalid_input: $v.cargo.nombreEntePublico.$error}"
          ></b-form-input>
          
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="ÁREA DE ADSCRIPCIÓN">
          <b-form-input
            :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.areaAdscripcion"
            placeholder="ÁREA DE ADSCRIPCIÓN"
            :class="{invalid_input: $v.cargo.areaAdscripcion.$error}"
          ></b-form-input>
          
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label >EMPLEO, CARGO O COMISIÓN</label>
          <b-form-input
            :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.empleoCargoComision"
            placeholder="EMPLEO, CARGO O COMISIÓN"
            :class="{invalid_input: $v.cargo.empleoCargoComision.$error}"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="¿ESTÁ CONTRATADO POR HONORARIOS?">
          <b-form-radio-group
            :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'" v-model="cargo.contratadoPorHonorarios" >
            <b-form-radio :value="true">SI</b-form-radio>
            <b-form-radio :value="false">NO</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
       <b-col md="6">
        <b-form-group>
          <label>NIVEL DEL EMPLEO, CARGO O COMISIÓN</label>
          <b-form-input
            :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.nivelEmpleoCargoComision"
            :class="{invalid_input: $v.cargo.nivelEmpleoCargoComision.$error}"
            placeholder="NIVEL DEL EMPLEO, CARGO O COMISIÓN"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group>
          <label>FUNCIÓN PRINCIPAL</label>
          <b-form-input
            :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.funcionPrincipal"
            :class="{invalid_input: $v.cargo.funcionPrincipal.$error}"
            placeholder="FUNCIÓN PRINCIPAL"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="FECHA DE TOMA DE POSESIÓN">
          <datetime
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
          :input-class="'form-control input'"
          v-model="cargo.fechaTomaPosesion"
          :class="{invalid_input: $v.cargo.fechaTomaPosesion.$error}"
          type="date" 
          />
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label>TELEFONO DE OFICINA</label>
          <b-form-input
            :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.telefonoOficina.telefono"
            placeholder="TELEFONO"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label>EXTENSIÓN</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.telefonoOficina.extension"
            placeholder="EXTENSIÓN"
          ></b-form-input>
        </b-form-group>
      </b-col>
      </b-row>
      <b-col md="12">
        <b-form-group style="text-align: center" label="DOMICILIO DEL EMPLEO, CARGO O COMISIÓN">
          <b-form-radio-group :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'" v-model="mexicano">
            <b-form-radio :value="true">MÉXICO</b-form-radio>
            <b-form-radio :value="false">EXTRANJERO</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
  

    <b-row v-if="!mexicano">
      <b-col md="2">
        <b-form-group>
          <label>PAÍS</label>
          <b-form-select
            :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="clavesPais"
            :options="pais"
            text-field="nombre"
            value-field="clave"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label>CALLE</label>
          <b-form-input
            :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.domicilioExtranjero.calle"
            placeholder="CALLE"
             
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="2">
        <b-form-group>
          <label>NO EXT</label>
          <b-form-input
            :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.domicilioExtranjero.numeroExterior"
            placeholder="NUM EXTERIOR"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="2">
        <b-form-group>
          <label>NO INT</label>
          <b-form-input
            :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.domicilioExtranjero.numeroInterior"
            placeholder="NUM INTERIOR"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label>CIUDAD</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.domicilioExtranjero.ciudadLocalidad"
            placeholder="CIUDAD"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <label>ESTADO O PROVINCIA</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.domicilioExtranjero.estadoProvincia"
            placeholder="ESTADO O PROVINCIA"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label>CÓDIGO POSTAL</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.domicilioExtranjero.codigoPostal"
            placeholder="CÓDIGO POSTAL"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- AQUI ES MEXICO-->
    <b-row v-else>
      <b-col md="8">
        <b-form-group>
          <label>CALLE</label>
          <b-form-input
            :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.domicilioMexico.calle"
            placeholder="CALLE"
            :class="{invalid_input: $v.cargo.domicilioMexico.calle.$error}"
            
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="2">
        <b-form-group>
          <label>NO. EXT</label>
          <b-form-input
            :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.domicilioMexico.numeroExterior"
            placeholder="NÚM EXTERIOR"
           :class="{invalid_input: $v.cargo.domicilioMexico.numeroExterior.$error}"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="2">
        <b-form-group>
          <label>NO. INT</label>
          <b-form-input
            :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.domicilioMexico.numeroInterior"
            placeholder="NUM INTERIOR"
            
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label>ENTIDAD FEDERATIVA</label>
          <b-form-select
            :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="encuentraEstadoValor()"
            v-model="cargo.domicilioMexico.entidadFederativa.clave"
            :options="estados"
            text-field="valor"
            value-field="clave"
          >
        </b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label>MUNICIPIO</label>
          <b-form-select
            :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="encuentraMuniValor()"
            :options="cargaMunicipio"
            v-model="cargo.domicilioMexico.municipioAlcaldia.clave"
            text-field="valor"
            value-field="clave"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label>COLONIA</label>
          <b-form-input
            :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.domicilioMexico.coloniaLocalidad"
            placeholder="COLONIA"
            :class="{invalid_input: $v.cargo.domicilioMexico.coloniaLocalidad.$error}"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label>CÓDIGO POSTAL</label>
          <b-form-input
           :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.domicilioMexico.codigoPostal"
            :class="{invalid_input: $v.cargo.domicilioMexico.codigoPostal.$error}"
            placeholder="CÓDIGO POSTAL"
            
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group>
          <label>ACLARACIONES / OBSERVACIONES</label>
          <b-form-input
            :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.aclaracionesObservaciones"
            placeholder="ACLARACIONES / OBSERVACIONES"
            
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="tipoDeclaracion === 'MODIFICACION'">
      <b-col md="3">
        <b-form-group label="¿Tiene otro cargo o comisión?">
          <b-form-radio-group id="otrocar" v-model="banderaOtro" :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'">
            <b-form-radio :value="false">No</b-form-radio>
            <b-form-radio :value="true">Si</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>

    <!------------------------------------------------------segundos datos------------------------------------------------------------>

    <b-row v-if="banderaOtro">
      <br />
      <br />

      <b-col md="12">
        <div class="customHr">.</div>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label for="dependencia">Dependencia o entidad:</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.otroEmpleoCargoComision.nombreEntePublico"
            type="text"
            id="dependencia"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group label="Nivel u orden de Gobierno: ">
          <b-form-select
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            :options="nivelOrdenGobierno"
            v-model="cargo.otroEmpleoCargoComision.nivelOrdenGobierno"
            class="mb-3"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group label="Ámbito Público: ">
          <b-form-select
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            :options="ambitoPublico"
            v-model="cargo.otroEmpleoCargoComision.ambitoPublico"
            class="mb-3"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label for="area">Área de adscripción</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.otroEmpleoCargoComision.areaAdscripcion"
            type="text"
            id="area"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label for="nombre">Nombre del empleo cargo o comisión</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.otroEmpleoCargoComision.empleoCargoComision"
            type="text"
            id="empleo"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label for="funcion">Función principal</label>
          <b-form-input :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.otroEmpleoCargoComision.funcionPrincipal"
            type="text"
            id="funcion"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="¿Está contratado por honorarios?">
          <b-form-radio-group :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            id="radios3"
            name="honorarios2"
            v-model="cargo.otroEmpleoCargoComision.contratadoPorHonorarios"
          >
            <b-form-radio :value="true">SI</b-form-radio>
            <b-form-radio :value="false">NO</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label for="nivel">Nivel del encargo:</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.otroEmpleoCargoComision.nivelEmpleoCargoComision"
            type="text"
            id="nivel"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group label="Fecha de toma de posesión:">
          <datetime
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            :input-class="'form-control input'"
            v-model="cargo.otroEmpleoCargoComision.fechaTomaPosesion"
            type="date"  placeholder="Selecciona fecha"
          />
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label for="nivel">Telefono oficina:</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.otroEmpleoCargoComision.telefonoOficina.telefono"
            type="text"
            id="tel"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="2">
        <b-form-group>
          <label for="nivel">Extensión:</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="cargo.otroEmpleoCargoComision.telefonoOficina.extension"
            type="text"
            id="ex"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="Lugar donde se ubica:">
          <b-form-radio-group
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            id="extranjero"
            v-model="extranjero2"
            @change="llenaEspacios2()"
            name="lugarUbica"
          >
            <b-form-radio :value="false">México</b-form-radio>
            <b-form-radio :value="true">Extranjero</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="!mexicano && banderaOtro">
      <b-col md="2">
        <b-form-group>
          <label>País:</label>
          <b-form-select
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            v-model="clavesPais2"
            :options="pais"
            text-field="nombre"
            value-field="clave"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label>Calle:</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            type="text"
            v-model="cargo.otroEmpleoCargoComision.domicilioExtranjero.calle"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label>Número exterior:</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            type="text"
            v-model="
              cargo.otroEmpleoCargoComision.domicilioExtranjero.numeroExterior
            "
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label>Número interior:</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            type="text"
            v-model="
              cargo.otroEmpleoCargoComision.domicilioExtranjero.numeroInterior
            "
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label>Ciudad:</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            type="text"
            v-model="
              cargo.otroEmpleoCargoComision.domicilioExtranjero.ciudadLocalidad
            "
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <label>Estado Provincia:</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            type="text"
            v-model="
              cargo.otroEmpleoCargoComision.domicilioExtranjero.estadoProvincia
            "
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label>Código postal:</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            type="text"
            v-model="
              cargo.otroEmpleoCargoComision.domicilioExtranjero.codigoPostal
            "
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="mexicano && banderaOtro">
      <b-col md="6">
        <b-form-group>
          <label>Calle:</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            type="text"
            v-model="cargo.otroEmpleoCargoComision.domicilioMexico.calle"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label>Número exterior:</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            type="text"
            v-model="
              cargo.otroEmpleoCargoComision.domicilioMexico.numeroExterior
            "
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label>Número interior:</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            type="text"
            v-model="
              cargo.otroEmpleoCargoComision.domicilioMexico.numeroInterior
            "
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label>Entidad Federativa:</label>
          <b-form-select
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="encuentraEstadoValorOtro()"
            v-model="
              cargo.otroEmpleoCargoComision.domicilioMexico.entidadFederativa
                .clave
            "
            :options="estados"
            text-field="valor"
            value-field="clave"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="2">
        <b-form-group>
          <label>Municipio:</label>
          <b-form-select
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="encuentraMuniValorOtro()"
            :options="cargaMunicipio"
            v-model="
              cargo.otroEmpleoCargoComision.domicilioMexico.municipioAlcaldia
                .clave
            "
            text-field="valor"
            value-field="clave"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label>Colonia o localidad:</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            type="text"
            v-model="
              cargo.otroEmpleoCargoComision.domicilioMexico.coloniaLocalidad
            "
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label>Código postal:</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            type="text"
            v-model="cargo.otroEmpleoCargoComision.domicilioMexico.codigoPostal"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group>
          <label>ACLARACIONES / OBSERVACIONES</label>
          <b-form-input
          :disabled="status === 'Concluida' || cargo.tipoOperacion == 'SIN CAMBIOS'"
            @change="cambios = true"
            type="text"
            v-model="cargo.otroEmpleoCargoComision.aclaracionesObservaciones"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
   
    <b-row>
      <b-col >
        <b-button variant="success" @click="verSeccion(0)" :disabled="enviando">Regresar al índice</b-button>
      </b-col>

      <b-col>
        <p v-if="cambios" class="error-text"><i>No se han guardado los cambios</i> </p>
      </b-col> 
      <b-col >
        <b-button variant="secondary" @click="verSeccion(3)" :disabled="enviando">Anterior</b-button>
        <b-button
          class="pull-right"
          variant="primary"
          @click="actualizarSeccion()"
          :disabled="enviando"
        >Siguiente</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";
const { dt } = require("luxon");
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { paises } from "../../../store/paises";
import { muni } from "../../../store/municipios";
import { required } from "vuelidate/lib/validators";
export default {
  name:"datosEmpleoCargo",
  props: ["cargo", "tipoDeclaracion", "status"],
  components: { Datetime, Loader},
  validations:{
    cargo:{  
      tipoOperacion:{required},
      nombreEntePublico: {required},
      areaAdscripcion: {required},
      empleoCargoComision: {required},
      nivelEmpleoCargoComision: {required},
      funcionPrincipal: {required},
      fechaTomaPosesion: {required},
      domicilioMexico:{
          calle:{required},
          numeroExterior:{required},
          coloniaLocalidad:{required},
          codigoPostal:{required}
          
        }
    },
  },

  computed: {
    ...mapGetters(["httpURL", "sessionToken"]),
    
    cargaMunicipio2() {
      let listaMuni = [];

      if (this.estadoClave2 !== null) {
        this.municipios.forEach(value => {
          if (value.claveEstado === this.estadoClave2) {
            listaMuni.push(value);
          }
        });
      }
      return listaMuni.sort();
    },
    cargaMunicipio() {
      let listaMuni = [];

      if (this.cargo.domicilioMexico.entidadFederativa.clave !== null) {
        this.municipios.forEach(value => {
          if ( value.claveEstado ===  this.cargo.domicilioMexico.entidadFederativa.clave ) {
            listaMuni.push(value);
          }
        });
      }
      return listaMuni
    },
  },
  data: function() {
    return {
      titulo: this.$route.name,
      enviando: false,
      cambios: false,
      nivelOrdenGobierno: ["FEDERAL", "ESTATAL", "MUNICIPAL_ALCALDIA"],
      ambitoPublico: [ "EJECUTIVO", "LEGISLATIVO", "JUDICIAL","ORGANO AUTONOMO" ],
      extranjero2: false,
      pais: paises,
      estadoNombre: null,
      estadoNombre2: null,
      estadoClave: null,
      estadoClave2: null,
      muniNombre: null,
      muniNombre2: null,
      muniClave: null,
      muniClave2: null,
      clavesPais: "",
      clavesPais2: "",
      municipios: muni,
      estados: [
        { clave: "01", valor: "AGUASCALIENTES" },
        { clave: "02", valor: "BAJA CALIFORNIA" },
        { clave: "03", valor: "BAJA CALIFORNIA SUR" },
        { clave: "04", valor: "CAMPECHE" },
        { clave: "05", valor: "COAHUILA DE ZARAGOZA" },
        { clave: "06", valor: "COLIMA" },
        { clave: "07", valor: "CHIAPAS" },
        { clave: "08", valor: "CHIHUAHUA" },
        { clave: "09", valor: "DISTRITO FEDERAL" },
        { clave: "10", valor: "DURANGO" },
        { clave: "11", valor: "GUANAJUATO" },
        { clave: "12", valor: "GUERRERO" },
        { clave: "13", valor: "HIDALGO" },
        { clave: "14", valor: "JALISCO" },
        { clave: "15", valor: "MÉXICO" },
        { clave: "16", valor: "MICHOACÁN DE OCAMPO" },
        { clave: "17", valor: "MORELOS" },
        { clave: "18", valor: "NAYARIT" },
        { clave: "19", valor: "NUEVO LEÓN" },
        { clave: "20", valor: "OAXACA" },
        { clave: "21", valor: "PUEBLA" },
        { clave: "22", valor: "QUERÉTARO" },
        { clave: "23", valor: "QUINTANA ROO" },
        { clave: "24", valor: "SAN LUIS POTOSÍ" },
        { clave: "25", valor: "SINALOA" },
        { clave: "26", valor: "SONORA" },
        { clave: "27", valor: "TABASCO" },
        { clave: "28", valor: "TAMAULIPAS" },
        { clave: "29", valor: "TLAXCALA" },
        { clave: "30", valor: "VERACRUZ DE IGNACIO DE LA LLAVE" },
        { clave: "31", valor: "YUCATÁN" },
        { clave: "32", valor: "ZACATECAS" }
      ],
      banderaOtro: false,
      mexicano:true,
      
    };
  },

  methods: {
   
    encuentraEstadoValor() {
      let indice = this.estados.findIndex(x => x.clave === this.cargo.domicilioMexico.entidadFederativa.clave );
      this.cargo.domicilioMexico.entidadFederativa.valor = this.estados[indice].valor;
    },
    encuentraMuniValorOtro() {
      let indice;
      indice = this.municipios.findIndex(
        x =>
          x.clave ===
          this.cargo.otroEmpleoCargoComision.domicilioMexico.municipioAlcaldia
            .clave
      );
      this.cargo.otroEmpleoCargoComision.domicilioMexico.municipioAlcaldia.valor = this.municipios[
        indice
      ].valor;
    },
    encuentraEstadoValorOtro() {
      let indice;
      indice = this.estados.findIndex(
        x =>
          x.clave ===
          this.cargo.otroEmpleoCargoComision.domicilioMexico.entidadFederativa
            .clave
      );
      this.cargo.otroEmpleoCargoComision.domicilioMexico.entidadFederativa.valor = this.estados[
        indice
      ].valor;
    },
    encuentraMuniValor() {
      let muni = this.cargaMunicipio
     
      let indice = muni.findIndex(x => x.clave === this.cargo.domicilioMexico.municipioAlcaldia.clave);
      this.cargo.domicilioMexico.municipioAlcaldia.valor = muni[indice].valor;
      //console.log(this.cargo.domicilioMexico.municipioAlcaldia.valor);

    },
    actualizarSeccion() {
      
     
        let siguiente = false
        if(this.mexicano){
          
         this.$v.$touch();  
        
          if (!this.$v.$invalid) {
           siguiente = true
           
         }
        
        }
        else siguiente = true
        if(siguiente){
         //console.log(this.cargo.domicilioMexico);
          this.enviando = true;
          if (this.tipoDeclaracion === "INICIAL" || this.tipoDeclaracion === "CONCLUSION" ) {
            axios.put(this.httpURL +"/declaraciones/V2/datosEmpleoCargoComision/" + this.$route.params.id,
              {
                  mexicano:this.mexicano,
                  tipoOperacion:this.cargo.tipoOperacion,
                  nivelOrdenGobierno: this.cargo.nivelOrdenGobierno,
                  ambitoPublico: this.cargo.ambitoPublico,
                  nombreEntePublico: this.cargo.nombreEntePublico,
                  areaAdscripcion: this.cargo.areaAdscripcion,
                  empleoCargoComision: this.cargo.empleoCargoComision,
                  contratadoPorHonorarios: this.cargo.contratadoPorHonorarios,
                  nivelEmpleoCargoComision: this.cargo.nivelEmpleoCargoComision,
                  funcionPrincipal: this.cargo.funcionPrincipal,
                  fechaTomaPosesion: this.cargo.fechaTomaPosesion,
                  telefonoOficinaTelefono: this.cargo.telefonoOficina.telefono,
                  telefonoOficinaExtension: this.cargo.telefonoOficina.extension,
                  MXcalle: this.cargo.domicilioMexico.calle,
                  MXnumeroExterior: this.cargo.domicilioMexico.numeroExterior,
                  MXnumeroInterior: this.cargo.domicilioMexico.numeroInterior,
                  MXcoloniaLocalidad: this.cargo.domicilioMexico.coloniaLocalidad,
                  MXmunicipioAlcaldiaClave: this.cargo.domicilioMexico.municipioAlcaldia.clave,
                  MXmunicipioAlcaldiaValor: this.cargo.domicilioMexico.municipioAlcaldia.valor,
                  MXentidadFederativaClave: this.cargo.domicilioMexico.entidadFederativa.clave,
                  MXentidadFederativaValor: this.cargo.domicilioMexico.entidadFederativa.valor,
                  MXcodigoPostal: this.cargo.domicilioMexico.codigoPostal,
                  EXTcalle: this.cargo.domicilioExtranjero.calle,
                  EXTnumeroExterior: this.cargo.domicilioExtranjero.numeroExterior,
                  EXTnumeroInterior: this.cargo.domicilioExtranjero.numeroInterior,
                  EXTciudadLocalidad: this.cargo.domicilioExtranjero.ciudadLocalidad,
                  EXTestadoProvincia: this.cargo.domicilioExtranjero.estadoProvincia,
                  EXTpais: this.clavesPais,
                  EXTcodigoPostal: this.cargo.domicilioExtranjero.codigoPostal,
                  aclaracionesObservaciones: this.cargo.aclaracionesObservaciones
              },
              { headers: { token: this.sessionToken } })
              .then(res => {
              this.$notify({ group: "foo",type: "success",duration: 2500,speed: 1000,text: res.data.mensaje });
              this.enviando = false;
              this.cambios = false;
            
              
              })
              .catch(error => {
                this.$notify({group: "foo",type: "error",duration: 2500,speed: 1000,text: "No se pudo guardar la sección."});  
                this.enviando = false;
              });
          } else if (this.tipoDeclaracion === "MODIFICACION") {

            if (this.banderaOtro) {
              axios .put( this.httpURL + "/declaraciones/V2/datosEmpleoCargoComision/" + this.$route.params.id,
                  {
                    tipoOperacion: this.cargo.tipoOperacion,
                    nivelOrdenGobierno: this.cargo.nivelOrdenGobierno,
                    ambitoPublico: this.cargo.ambitoPublico,
                    nombreEntePublico: this.cargo.nombreEntePublico,
                    areaAdscripcion: this.cargo.areaAdscripcion,
                    empleoCargoComision: this.cargo.empleoCargoComision,
                    contratadoPorHonorarios: this.cargo.contratadoPorHonorarios,
                    nivelEmpleoCargoComision: this.cargo.nivelEmpleoCargoComision,
                    funcionPrincipal: this.cargo.funcionPrincipal,
                    fechaTomaPosesion: this.cargo.fechaTomaPosesion,
                    telefonoOficinaTelefono: this.cargo.telefonoOficina.telefono,
                    telefonoOficinaExtension: this.cargo.telefonoOficina.extension,
                    MXcalle: this.cargo.domicilioMexico.calle,
                    MXnumeroExterior: this.cargo.domicilioMexico.numeroExterior,
                    MXnumeroInterior: this.cargo.domicilioMexico.numeroInterior,
                    MXcoloniaLocalidad: this.cargo.domicilioMexico.coloniaLocalidad,
                    MXmunicipioAlcaldiaClave: this.cargo.domicilioMexico.municipioAlcaldia.clave,
                    MXmunicipioAlcaldiaValor: this.cargo.domicilioMexico.municipioAlcaldia.valor,
                    MXentidadFederativaClave: this.cargo.domicilioMexico.entidadFederativa.clave,
                    MXentidadFederativaValor: this.cargo.domicilioMexico.entidadFederativa.valor,
                    MXcodigoPostal: this.cargo.domicilioMexico.codigoPostal,
                    EXTcalle: this.cargo.domicilioExtranjero.calle,
                    EXTnumeroExterior: this.cargo.domicilioExtranjero.numeroExterior,
                    EXTnumeroInterior: this.cargo.domicilioExtranjero.numeroInterior,
                    EXTciudadLocalidad: this.cargo.domicilioExtranjero.ciudadLocalidad,
                    EXTestadoProvincia: this.cargo.domicilioExtranjero.estadoProvincia,
                    EXTpais: this.clavesPais,
                    EXTcodigoPostal: this.cargo.domicilioExtranjero.codigoPostal,
                    aclaracionesObservaciones: this.cargo.aclaracionesObservaciones,
                    cuentaConOtroCargoPublico: this.banderaOtro,
                    otronivelOrdenGobierno: this.cargo.otroEmpleoCargoComision.nivelOrdenGobierno,
                    otroambitoPublico: this.cargo.otroEmpleoCargoComision.ambitoPublico,
                    otronombreEntePublico: this.cargo.otroEmpleoCargoComision.nombreEntePublico,
                    otroareaAdscripcion: this.cargo.otroEmpleoCargoComision.areaAdscripcion,
                    otroempleoCargoComision: this.cargo.otroEmpleoCargoComision.empleoCargoComision,
                    otrocontratadoPorHonorarios: this.cargo.otroEmpleoCargoComision.contratadoPorHonorarios,
                    otronivelEmpleoCargoComision: this.cargo.otroEmpleoCargoComision.empleoCargoComision,
                    otrofuncionPrincipal: this.cargo.otroEmpleoCargoComision.funcionPrincipal,
                    otrofechaTomaPosesion: this.cargo.otroEmpleoCargoComision.fechaTomaPosesion,
                    otrotelefonoOficinaTelefono: this.cargo.otroEmpleoCargoComision.telefonoOficina.telefono,
                    otrotelefonoOficinaExtension: this.cargo.otroEmpleoCargoComision.telefonoOficina.extension,
                    otroMXcalle: this.cargo.otroEmpleoCargoComision.domicilioMexico.calle,
                    otroMXnumeroExterior: this.cargo.otroEmpleoCargoComision.domicilioMexico.numeroExterior,
                    otroMXnumeroInterior: this.cargo.otroEmpleoCargoComision.domicilioMexico.numeroInterior,
                    otroMXcoloniaLocalidad: this.cargo.otroEmpleoCargoComision.domicilioMexico.coloniaLocalidad,
                    otroMXmunicipioAlcaldiaClave: this.cargo.otroEmpleoCargoComision.domicilioMexico.municipioAlcaldia.clave,
                    otroMXmunicipioAlcaldiaValor: this.cargo.otroEmpleoCargoComision.domicilioMexico.municipioAlcaldia.valor,
                    otroMXentidadFederativaClave: this.cargo.otroEmpleoCargoComision.domicilioMexico.entidadFederativa.clave,
                    otroMXentidadFederativaValor: this.cargo.otroEmpleoCargoComision.domicilioMexico.entidadFederativa.valor,
                    otroMXcodigoPostal: this.cargo.otroEmpleoCargoComision.domicilioMexico.codigoPostal,
                    otroEXTcalle: this.cargo.otroEmpleoCargoComision.domicilioExtranjero.calle,
                    otroEXTnumeroExterior: this.cargo.otroEmpleoCargoComision.domicilioExtranjero.numeroExterior,
                    otroEXTnumeroInterior: this.cargo.otroEmpleoCargoComision.domicilioExtranjero.numeroInterior,
                    otroEXTciudadLocalidad: this.cargo.otroEmpleoCargoComision.domicilioExtranjero.ciudadLocalidad,
                    otroEXTestadoProvincia: this.cargo.otroEmpleoCargoComision.domicilioExtranjero.estadoProvincia,
                    otroEXTpais: this.clavesPais2,
                    otroEXTcodigoPostal: this.cargo.otroEmpleoCargoComision.domicilioExtranjero.codigoPostal,
                    otroaclaracionesObservaciones: this.cargo.otroEmpleoCargoComision.aclaracionesObservaciones
                  },
                  { headers: { token: this.sessionToken } }
                )
                .then(res => {
                
                  this.$notify({ group: "foo",type: "success",duration: 2500,speed: 1000,  text: res.data.mensaje});
                  this.enviando = false;
                  this.cambios = false;
                })
                .catch(error => {
                  this.$notify({group: "foo",  type: "error", duration: 2500,speed: 1000, text: "No se pudo guardar la sección."});
                  this.enviando = false;
                });
            } else {
           
              axios.put(this.httpURL +"/declaraciones/V2/datosEmpleoCargoComision/" +this.$route.params.id,
                  {
                    mexicano:this.mexicano,
                    tipoOperacion: this.cargo.tipoOperacion,
                    nivelOrdenGobierno: this.cargo.nivelOrdenGobierno,
                    ambitoPublico: this.cargo.ambitoPublico,
                    nombreEntePublico: this.cargo.nombreEntePublico,
                    areaAdscripcion: this.cargo.areaAdscripcion,
                    empleoCargoComision: this.cargo.empleoCargoComision,
                    contratadoPorHonorarios: this.cargo.contratadoPorHonorarios,
                    nivelEmpleoCargoComision: this.cargo.nivelEmpleoCargoComision,
                    funcionPrincipal: this.cargo.funcionPrincipal,
                    fechaTomaPosesion: this.cargo.fechaTomaPosesion,
                    telefonoOficinaTelefono: this.cargo.telefonoOficina.telefono,
                    telefonoOficinaExtension: this.cargo.telefonoOficina.extension,
                    MXcalle: this.cargo.domicilioMexico.calle,
                    MXnumeroExterior: this.cargo.domicilioMexico.numeroExterior,
                    MXnumeroInterior: this.cargo.domicilioMexico.numeroInterior,
                    MXcoloniaLocalidad: this.cargo.domicilioMexico.coloniaLocalidad,
                    MXmunicipioAlcaldiaClave: this.cargo.domicilioMexico
                      .municipioAlcaldia.clave,
                    MXmunicipioAlcaldiaValor: this.cargo.domicilioMexico
                      .municipioAlcaldia.valor,
                    MXentidadFederativaClave: this.cargo.domicilioMexico
                      .entidadFederativa.clave,
                    MXentidadFederativaValor: this.cargo.domicilioMexico
                      .entidadFederativa.valor,
                    MXcodigoPostal: this.cargo.domicilioMexico.codigoPostal,
                    EXTcalle: this.cargo.domicilioExtranjero.calle,
                    EXTnumeroExterior: this.cargo.domicilioExtranjero
                      .numeroExterior,
                    EXTnumeroInterior: this.cargo.domicilioExtranjero
                      .numeroInterior,
                    EXTciudadLocalidad: this.cargo.domicilioExtranjero
                      .ciudadLocalidad,
                    EXTestadoProvincia: this.cargo.domicilioExtranjero
                      .estadoProvincia,
                    EXTpais: this.clavesPais,
                    EXTcodigoPostal: this.cargo.domicilioExtranjero.codigoPostal,
                    aclaracionesObservaciones: this.cargo.aclaracionesObservaciones,
                    cuentaConOtroCargoPublico: this.banderaOtro,
                    otronivelOrdenGobierno: "",
                    otroambitoPublico: "",
                    otronombreEntePublico: "",
                    otroareaAdscripcion: "",
                    otroempleoCargoComision: "",
                    otrocontratadoPorHonorarios: false,
                    otronivelEmpleoCargoComision: "",
                    otrofuncionPrincipal: "",
                    otrofechaTomaPosesion: "",
                    otrotelefonoOficinaTelefono: 0,
                    otrotelefonoOficinaExtension: 0,
                    otroMXcalle: "",
                    otroMXnumeroExterior: 0,
                    otroMXnumeroInterior: 0,
                    otroMXcoloniaLocalidad: "",
                    otroMXmunicipioAlcaldiaClave: "",
                    otroMXmunicipioAlcaldiaValor: "",
                    otroMXentidadFederativaClave: "",
                    otroMXentidadFederativaValor: "",
                    otroMXcodigoPostal: 0,
                    otroEXTcalle: "",
                    otroEXTnumeroExterior: 0,
                    otroEXTnumeroInterior: 0,
                    otroEXTciudadLocalidad: "",
                    otroEXTestadoProvincia: "",
                    otroEXTpais: "",
                    otroEXTcodigoPostal: 0,
                    otroaclaracionesObservaciones: ""
              
                  },
                  { headers: { token: this.sessionToken } }
                )
                .then(res => {  
                  this.$notify({ group: "foo",type: "success", duration: 2500, speed: 1000, text: res.data.mensaje });
                  this.enviando = false;
                  this.cambios = false;
                })
                .catch(error => {
                  this.$notify({
                    group: "foo",
                    type: "error",
                    duration: 2500,
                    speed: 1000,
                    text: "No se pudo guardar la sección."
                  });
                  this.enviando = false;
                });
            }
          }
          this.verSeccion(5)
         }
          
      
    
    },
    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    },

    llenaEspacios() {
      if (this.extranjero) {
        this.cargo.domicilioMexico.calle = "";
        this.cargo.domicilioMexico.numeroExterior = "";
        this.cargo.domicilioMexico.numeroInterior = "";
        this.cargo.domicilioMexico.coloniaLocalidad = "";
        this.muniClave = "";
        this.muniNombre = "";
        this.cargo.domicilioMexico.entidadFederativa.clave = ""
        this.cargo.domicilioMexico.entidadFederativa.valor = ""
        this.cargo.domicilioMexico.codigoPostal = "";
       
      } else {
         this.cargo.domicilioExtranjero.calle = "";
        this.cargo.domicilioExtranjero.numeroExterior = "";
        this.cargo.domicilioExtranjero.numeroInterior = "";
        this.cargo.domicilioExtranjero.ciudadLocalidad = "";
        this.cargo.domicilioExtranjero.estadoProvincia = "";
        this.clavesPais = "";
        this.cargo.domicilioExtranjero.codigoPostal = "";
        this.cargo.aclaracionesObservaciones = "";
      }
    },
    llenaEspacios2() {
      if (this.extranjero2 === false) {
        this.cargo.otroEmpleoCargoComision.domicilioExtranjero.calle = "";
        this.cargo.otroEmpleoCargoComision.domicilioExtranjero.numeroExterior =
          "";
        this.cargo.otroEmpleoCargoComision.domicilioExtranjero.numeroInterior =
          "";
        this.cargo.otroEmpleoCargoComision.domicilioExtranjero.ciudadLocalidad =
          "";
        this.cargo.otroEmpleoCargoComision.domicilioExtranjero.estadoProvincia =
          "";
        this.clavesPais2 = "";
        this.cargo.otroEmpleoCargoComision.domicilioExtranjero.codigoPostal =
          "";
        this.cargo.otroEmpleoCargoComision.aclaracionesObservaciones = "";
      } else {
        this.cargo.otroEmpleoCargoComision.domicilioMexico.calle = "";
        this.cargo.otroEmpleoCargoComision.domicilioMexico.numeroExterior = "";
        this.cargo.otroEmpleoCargoComision.domicilioMexico.numeroInterior = "";
        this.cargo.otroEmpleoCargoComision.domicilioMexico.coloniaLocalidad =
          "";
        this.muniClave2 = "";
        this.muniNombre2 = "";
        this.estadoClave2 = "";
        this.estadoNombre2 = "";
        this.cargo.otroEmpleoCargoComision.domicilioMexico.codigoPostal = "";
      }
    }
  },

  created() {
    //console.log(this.cargo);
    this.estados.sort();
    
    //this.cargo.tipoOperacion  = this.cargo.tipoOperacion ? this.cargo.tipoOperacion : 'AGREGAR'
    this.cargo.contratadoPorHonorarios = this.cargo.contratadoPorHonorarios ? this.cargo.contratadoPorHonorarios : false
    this.cargo.ambitoPublico = this.cargo.ambitoPublico ? this.cargo.ambitoPublico : this.ambitoPublico[0]
    this.cargo.nivelOrdenGobierno = this.cargo.nivelOrdenGobierno ? this.cargo.nivelOrdenGobierno : this.nivelOrdenGobierno[0]
    //this.cargo.fechaTomaPosesion = this.cargo.fechaTomaPosesion ? this.cargo.fechaTomaPosesion : "";
    this.mexicano = !this.cargo.domicilioMexico.calle && !this.cargo.domicilioExtranjero.calle ? true : this.cargo.domicilioMexico ? true : false ;
    this.cargo.domicilioMexico.entidadFederativa.clave = this.cargo.domicilioMexico.entidadFederativa.clave ? this.cargo.domicilioMexico.entidadFederativa.clave : this.estados[0].clave;
    this.cargo.domicilioMexico.entidadFederativa.valor = this.cargo.domicilioMexico.entidadFederativa.valor ? this.cargo.domicilioMexico.entidadFederativa.valor : this.estados[0].valor;
    this.cargo.domicilioMexico.municipioAlcaldia.clave = this.cargo.domicilioMexico.municipioAlcaldia.clave ? this.cargo.domicilioMexico.municipioAlcaldia.clave : this.cargaMunicipio[0].clave;
    this.cargo.domicilioMexico.municipioAlcaldia.valor = this.cargo.domicilioMexico.municipioAlcaldia.valor ? this.cargo.domicilioMexico.municipioAlcaldia.valor : this.cargaMunicipio[0].valor;
    
    if (this.cargo.cuentaConOtroCargoPublico === true) this.banderaOtro = true;
 
  }
};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
